<template>
  <pt-adult-sell-order-handle-table class="pt-adult-sell-order-handle-table__page"></pt-adult-sell-order-handle-table>
</template>

<script>
import PtAdultSellOrderHandleTable from 'cps/adult-sell-order/pt-adult-sell-order-handle/pt-adult-sell-order-handle-table/withData'
export default {
  name: 'pt-adult-sell-order-handle-table__view',
  components: {
    'pt-adult-sell-order-handle-table': PtAdultSellOrderHandleTable
  }
}
</script>
